import React from 'react';
import ColorBlock from '../color-block';
import styles from './color-block-list.module.scss';

interface Props {
  groupName: string;
  colors: {
    name: string;
    brand?: string;
    hex: string;
    variable: string;
  }[];
}

const ColorBlockList = ({groupName, colors}: Props) => (
  <label className={styles.container} htmlFor="color-blocks">
    {groupName}
    <ul id="color-blocks" className={styles.list}>
      {colors.map((color) => (
        <ColorBlock key={`${color.name}-block`} color={color} />
      ))}
    </ul>
  </label>
);

export default ColorBlockList;
